import { boolean, literal, type, union } from "superstruct";

const InstagramBaseLayoutSchema = type({
    sortBy: union([literal("newest_first"), literal("tagged_first")]),
    filter: union([literal("all"), literal("only_tagged")]),
    storiesEnabled: boolean(),
    postMediaFilter: union([literal("all"), literal("only_tagged")]),
    previewButtonTypeOnTaggedPost: union([
        literal("shop_it"),
        literal("hotspot"),
    ]),
    highQualityEnabled: boolean(),
    taggedGalleryOnly: boolean(),
    loadMoreEnabled: boolean(),
    productQuickViewEnabled: boolean(),
});

export default InstagramBaseLayoutSchema;
